import {
  UPDATE_COMPETITOR_PROFILE_REQUEST,
  UPDATE_COMPETITOR_PROFILE_SUCCESS,
  UPDATE_COMPETITOR_PROFILE_FAILURE,
} from "../actions/updateCompetitorProfileActions";

const initialState = {
  creating: false,
  success: false,
  error: null,
};

export default function updateCompetitorProfileReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case UPDATE_COMPETITOR_PROFILE_REQUEST:
      return {
        ...state,
        creating: true,
        success: false,
        error: null,
      };

    case UPDATE_COMPETITOR_PROFILE_SUCCESS:
      return {
        ...state,
        creating: false,
        success: true,
      };

    case UPDATE_COMPETITOR_PROFILE_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
